import Vue from "vue";
import new_order_change_applicationView from "./new_order_change_application/new_order_change_applicationDetail.vue";
// import quoteView from "./quotation/quotationEdit.vue";
var components = [
    //new_ord_saleorderView,
    {
        name: 'new_order_change_applicationView',
        component: new_order_change_applicationView
    },
    // {
    //     name: 'quoteView',
    //     component: quoteView
    // },

]
export default {
    install: function(Vue, opts) {
        components.map(function(component) {
            Vue.component(component.name, component.component);
        });
    },
};


// WEBPACK FOOTER //
// ./src/module/index.js